module.exports = __webpack_public_path__ + "assets/trane_commercial_logo-44729d32-pivot.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styl/images/trane_commercial_logo.svg
// module id = 321
// module chunks = 47